import request from "../../utils/request";

export default {
  state: {
    config: {
      email: "hirzone@126.com",
      webSite: "https://hirzone.com",
      company: "南京玄综文化",
      beian: "苏ICP备2023046287号-4X",
      appName: "玄综寻卜",
      toolName: "时空",
      showUserGuide: "true",
      silentLogin: "false",
      systemAvatar:
        "https://xz-xunbu.oss-cn-beijing.aliyuncs.com/logo/logo288x288.png",
      defaultAvatar:
        "https://xz-xunbu.oss-cn-beijing.aliyuncs.com/images/avatars/6b72daa5668949f186ee28e5198d3a7f.jpeg",
      myBg: JSON.stringify([
        {
          url: "https://xz-xunbu.oss-cn-beijing.aliyuncs.com/null219a53f93859489ab075934b42066881.png",
          uid: 1742655204217,
          name: "img_bg_top_me@2x.png",
        },
      ]),
    },
    status: false,
  },
  getters: {
    config: (state) => state.config,
    configStatus: (state) => state.status,
  },
  actions: {
    loadGlobalConfig({ state, commit }) {
      request({
        method: "get",
        params: {
          _gp: "sysConfig",
          _mt: "getGlobalConfig",
        },
      }).then((res) => {
        commit("setGlobalConfig", res.data.data);
        console.log(state.config);
      });
    },
  },
  mutations: {
    setConfig: (state, { value, key }) => {
      state.config[key] = value;
      uni.setStorageSync(key, value);
    },
    setGlobalConfig(state, data = []) {
      data.forEach((item) => {
        let [, key] = item.key.split(":");
        state.config[key] = item.value;
      });
      state.status = true;
    },
  },
};
